import React, { useState, useEffect } from "react";
import axios from "axios";
import OfficerNavbar from "./OfficerNavbar";
import * as XLSX from 'xlsx';
import StudentEditForm from "./StudentEditForm";
import { generatePrintHTML } from "./PrintPreviewComponent";
import {baseurl} from '../../url';
import "./approvedremoved.css";
import StudentPreviewModal from "./StudentPreviewModal";
import { getFeeCategoryDisplayName } from "../../utils";


const ApprovedAndRemoved = () => {
  const [approvedStudents, setApprovedStudents] = useState([]);
  const [filteredApproved, setFilteredApproved] = useState([]);
  const [removedStudents, setRemovedStudents] = useState([]);
  const [filteredRemoved, setFilteredRemoved] = useState([]);
  const [showRemoved, setShowRemoved] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [studentId, setStudentId] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [previewStudent, setPreviewStudent] = useState(null);
const [showPreview, setShowPreview] = useState(false);
  // Search and filter states for Approved Students
  const [approvedSearchTerm, setApprovedSearchTerm] = useState("");
  const [approvedCourseFilter, setApprovedCourseFilter] = useState("");
  
  // Search and filter states for Removed Students
  const [removedSearchTerm, setRemovedSearchTerm] = useState("");
  const [removedCourseFilter, setRemovedCourseFilter] = useState("");

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const approvedResponse = await axios.get(`${baseurl}/api/approvedStudents`);
        const removedResponse = await axios.get(`${baseurl}/api/removedStudents`);
  
        const currentYear = new Date().getFullYear().toString().slice(-2);
        const filteredStudents = approvedResponse.data
          .filter((student) => student?.admissionNumber?.split("/")[1] === currentYear)
          .reverse();
  
        setApprovedStudents(filteredStudents);
        setFilteredApproved(filteredStudents);
        setRemovedStudents(removedResponse.data);
        setFilteredRemoved(removedResponse.data);
      } catch (error) {
        console.error("Error fetching student data:", error);
      }
    };
  
    fetchStudents();
  }, []);

  // Filter Approved Students
  useEffect(() => {
    let filtered = [...approvedStudents];

    // Filter by search term (name, admission number)
    if (approvedSearchTerm) {
      const term = approvedSearchTerm.toLowerCase();
      filtered = filtered.filter(
        (student) =>
          student.name?.toLowerCase().includes(term) ||
          student.admissionNumber?.toLowerCase().includes(term)
      );
    }

    // Filter by course
    if (approvedCourseFilter) {
      filtered = filtered.filter(
        (student) => student.course === approvedCourseFilter
      );
    }

    setFilteredApproved(filtered);
  }, [approvedSearchTerm, approvedCourseFilter, approvedStudents]);

  // Filter Removed Students
  useEffect(() => {
    let filtered = [...removedStudents];

    // Filter by search term (name, admission ID)
    if (removedSearchTerm) {
      const term = removedSearchTerm.toLowerCase();
      filtered = filtered.filter(
        (student) =>
          student.name?.toLowerCase().includes(term) ||
          student.admissionId?.toLowerCase().includes(term)
      );
    }

    // Filter by course
    if (removedCourseFilter) {
      filtered = filtered.filter(
        (student) => student.course === removedCourseFilter
      );
    }

    setFilteredRemoved(filtered);
  }, [removedSearchTerm, removedCourseFilter, removedStudents]);

  const handleCourseChange = (e) => {
    setSelectedCourse(e.target.value);
  };

  const handleDelete = async (studentId) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this student?"
    );
    if (!confirm) return;

    try {
      await axios.delete(`${baseurl}/api/deleteStudent/${studentId}`);
      setApprovedStudents((prevStudents) =>
        prevStudents.filter((student) => student._id !== studentId)
      );
      alert("Student deleted successfully.");
    } catch (error) {
      console.error("Error declining student:", error);
    }
  };
const handlePreview = (student) => {
  setPreviewStudent(student);
  setShowPreview(true);
};

const handlePreviewEdit = () => {
  setShowPreview(false);
  handleEdit(previewStudent);
};
  const handleRetrieveStudent = async (studentId) => {
    const confirm = window.confirm(
      "Are you sure you want to retrieve this student back to the DataTable?"
    );
    if (!confirm) return;

    try {
      const response = await axios.post(`${baseurl}/api/move-to-approved/${studentId}`);
      alert(response.data.message);
      
      const approvedResponse = await axios.get(`${baseurl}/api/approvedStudents`);
      const removedResponse = await axios.get(`${baseurl}/api/removedStudents`);
      
      const currentYear = new Date().getFullYear().toString().slice(-2);
      const filteredStudents = approvedResponse.data
        .filter(student => student?.admissionNumber?.split("/")[1] === currentYear)
        .reverse();
      
      setApprovedStudents(filteredStudents);
      setRemovedStudents(removedResponse.data);
    } catch (error) {
      console.error("Error retrieving student:", error);
      alert("Failed to retrieve student.");
    }
  };

  const generateExcel = () => {
    const studentData = filteredApproved.map(student => ({
      Name: student.name,
      'Admission Type': student.admissionType,
      'Admission No:': student.admissionNumber,
      'Allotment Category': student.allotmentCategory,
      'FeeCategory': getFeeCategoryDisplayName(student.feeCategory),
      'Course': student.course,
      'Address': student.address,
      'Permanent Address': student.permanentAddress,
      'Pincode': student.pincode,
      'Religion': student.religion,
      'Community': student.community,
      'Category': student.category,
      'Date of Birth': student.dateOfBirth,
      'Gender': student.gender,
      'Blood Group': student.bloodGroup,
      'Mobile': student.mobileNo,
      'Whatsapp No': student.whatsappNo,
      'Email': student.email,
      'Entrance Exam Name': student.entranceExam,
      'Entrance Register No': student.entranceRollNo,
      'Entrance Rank': student.entranceRank,
      'plus Two Board': student.marks?.boardType,
      'plus Two Chemistry': student.marks?.chemistry,
      'plus Two Physics': student.marks?.physics,
      'plus Two Maths': student.marks?.maths,
      'Aadhaar Number': student.aadharNo,
      'Qualifying Exam Name': student.qualify?.exam,
      'Qualifying Exam Board': student.qualify?.board,
      'Institution Name': student.qualify?.institution,
      'Qualifying Exam RegisterNumber': student.qualify?.regNo,
      'Exam Year and Month': student.qualify?.examMonthYear,
      'Percentage': student.qualify?.percentage,
      'CGPA': student.qualify?.cgpa,
      'Father\'s Name': student.parentDetails?.fatherName,
      'Father\'s MobileNo': student.parentDetails?.fatherMobileNo,
      'Father\'s Occupation': student.parentDetails?.fatherOccupation,
      'Mother\'s Name': student.parentDetails?.motherName,
      'Mother\'s MobileNo': student.parentDetails?.motherMobileNo,
      'Mother\'s Occupation': student.parentDetails?.motherOccupation,
      'Annual Income': student.annualIncome,
      'Nativity': student.nativity,
    }));

    const worksheet = XLSX.utils.json_to_sheet(studentData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');
    XLSX.writeFile(workbook, 'ApprovedStudents.xlsx');
  };

  const handleremovedDelete = async (studentId) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this student?"
    );
    if (!confirm) return;

    try {
      await axios.delete(`${baseurl}/api/removedstudents/${studentId}`);
      setRemovedStudents((prevStudents) =>
        prevStudents.filter((student) => student._id !== studentId)
      );
      alert("Student deleted successfully.");
    } catch (error) {
      console.error("Error declining student:", error);
    }
  };

  const handlePrintPreview = async (_id, photoUrl) => {
    try {
      const response = await axios.get(
        `${baseurl}/api/approvedstudentDetails/${_id}`
      );
      
      const studentDetails = response.data.studentDetails;
      const feeDetails = response.data.studentDetails.feeDetails;

      if (!studentDetails || !studentDetails.parentDetails) {
        console.error("Error: Invalid student details received");
        return;
      }

      const htmlString = generatePrintHTML(studentDetails, feeDetails, photoUrl);
      const printWindow = window.open("", "_blank");
      printWindow.document.write(htmlString);
      printWindow.document.close();
    } catch (error) {
      console.error("Error generating print preview:", error);
    }
  };

  const handleEdit = (student) => {
    setSelectedStudent(student);
    setStudentId(student._id);
    setEditMode(true);
  };

  const handleSaveComplete = async () => {
    setEditMode(false);
    setSelectedStudent(null);
    const approvedResponse = await axios.get(`${baseurl}/api/approvedStudents`);
    const currentYear = new Date().getFullYear().toString().slice(-2);
    const filteredStudents = approvedResponse.data
      .filter(student => student?.admissionNumber?.split("/")[1] === currentYear)
      .reverse();
    setApprovedStudents(filteredStudents);
  };

  const clearApprovedFilters = () => {
    setApprovedSearchTerm("");
    setApprovedCourseFilter("");
  };

  const clearRemovedFilters = () => {
    setRemovedSearchTerm("");
    setRemovedCourseFilter("");
  };

  const hasApprovedFilters = approvedSearchTerm || approvedCourseFilter;
  const hasRemovedFilters = removedSearchTerm || removedCourseFilter;

  // Calculate stats
  const approvedCourseCounts = approvedStudents.reduce((acc, student) => {
    acc[student.course] = (acc[student.course] || 0) + 1;
    return acc;
  }, {});

  return (
    <div>
      <OfficerNavbar />
      <div className="approved-removed-wrapper">
        {!editMode ? (
          <div className="approved-removed-content">
            {/* Toggle Button */}
            <div className="ar-toggle-section">
              <button className="ar-toggle-btn" onClick={() => setShowRemoved(!showRemoved)}>
                {showRemoved ? "← Back to Approved Students" : "🗑️ View Removed Students"}
              </button>
            </div>

            {showRemoved ? (
              /* Removed Students Section */
              <div>
                <div className="ar-section-header">
                  <h2>Removed Students</h2>
                  <span className="ar-section-badge">
                    {filteredRemoved.length} of {removedStudents.length} records
                  </span>
                </div>

                {/* Search and Filter Toolbar for Removed Students */}
                <div className="ar-search-toolbar">
                  <div className="ar-search-group">
                    <input
                      type="text"
                      className="ar-search-input"
                      placeholder="🔍 Search by name or admission ID..."
                      value={removedSearchTerm}
                      onChange={(e) => setRemovedSearchTerm(e.target.value)}
                    />
                  </div>
                  <div className="ar-filter-group">
                    <label className="ar-filter-label">Course:</label>
                    <select
                      className="ar-filter-dropdown"
                      value={removedCourseFilter}
                      onChange={(e) => setRemovedCourseFilter(e.target.value)}
                    >
                      <option value="">All Courses</option>
                      <option value="B.Tech CSE">BTech CSE</option>
                      <option value="B.Tech ECE">BTech ECE</option>
                      <option value="BBA">BBA</option>
                      <option value="MCA">MCA</option>
                      <option value="BCA">BCA</option>
                    </select>
                  </div>
                  {hasRemovedFilters && (
                    <button className="ar-clear-filters-btn" onClick={clearRemovedFilters}>
                      ✕ Clear
                    </button>
                  )}
                </div>

                {/* Filter Info */}
                {hasRemovedFilters && (
                  <div className="ar-filter-info">
                    Showing {filteredRemoved.length} of {removedStudents.length} removed students
                  </div>
                )}

                {/* Removed Students Table */}
                <div className="ar-table-container">
                  <table className="ar-table">
                    <thead>
                      <tr>
                        <th>SI No</th>
                        <th>Name</th>
                        <th>Admission ID</th>
                        <th>Submission Date</th>
                        <th>Course</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRemoved.length > 0 ? (
                        filteredRemoved.map((student, index) => (
                          <tr key={student._id}>
                            <td>{index + 1}</td>
                            <td><strong>{student.name}</strong></td>
                            <td className="ar-mono-text">{student.admissionId}</td>
                            <td>{student.submissionDate}</td>
                            <td>
                              <span className="ar-status-removed">{student.course}</span>
                            </td>
                            <td>
                              <div className="ar-action-buttons">
                                <button
                                  className="ar-delete-btn"
                                  onClick={() => handleremovedDelete(student._id)}
                                >
                                  🗑️ Delete
                                </button>
                                <button
                                  className="ar-retrieve-btn"
                                  onClick={() => handleRetrieveStudent(student._id)}
                                >
                                  ↩️ Retrieve
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="ar-empty-state">
                            {hasRemovedFilters ? "No matching removed students found" : "No removed students found"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              /* Approved Students Section */
              <div>
                <div className="ar-section-header">
                  <h2>Approved Students</h2>
                  <span className="ar-section-badge">
                    {filteredApproved.length} of {approvedStudents.length} students
                  </span>
                </div>

                {/* Compact Stats */}
                <div className="ar-stats">
                  <div className="ar-stat-card">
                    <span className="stat-icon">📋</span>
                    <div className="stat-info">
                      <h4>Total</h4>
                      <p>{approvedStudents.length}</p>
                    </div>
                  </div>
                  {Object.entries(approvedCourseCounts).map(([course, count]) => (
                    <div className="ar-stat-card" key={course}>
                      <span className="stat-icon">🎓</span>
                      <div className="stat-info">
                        <h4>{course.includes("CSE") ? "CSE" : course.includes("ECE") ? "ECE" : course.includes("BBA") ? "BBA" : course.includes("MCA") ? "MCA" : course.includes("BCA") ? "BCA" : course}</h4>
                        <p>{count}</p>
                      </div>
                    </div>
                  ))}
                </div>
                
                {/* Search and Filter Toolbar for Approved Students */}
                <div className="ar-search-toolbar">
                  <div className="ar-search-group">
                    <input
                      type="text"
                      className="ar-search-input"
                      placeholder="🔍 Search by name or admission number..."
                      value={approvedSearchTerm}
                      onChange={(e) => setApprovedSearchTerm(e.target.value)}
                    />
                  </div>
                  <div className="ar-filter-group">
                    <label className="ar-filter-label">Course:</label>
                    <select
                      className="ar-filter-dropdown"
                      value={approvedCourseFilter}
                      onChange={(e) => setApprovedCourseFilter(e.target.value)}
                    >
                      <option value="">All Courses</option>
                      <option value="B.Tech CSE">BTech CSE</option>
                      <option value="B.Tech ECE">BTech ECE</option>
                      <option value="BBA">BBA</option>
                      <option value="MCA">MCA</option>
                      <option value="BCA">BCA</option>
                    </select>
                  </div>
                  <button className="ar-export-btn" onClick={generateExcel}>
                    📊 Export
                  </button>
                  {hasApprovedFilters && (
                    <button className="ar-clear-filters-btn" onClick={clearApprovedFilters}>
                      ✕ Clear
                    </button>
                  )}
                </div>

                {/* Filter Info */}
                {hasApprovedFilters && (
                  <div className="ar-filter-info">
                    Showing {filteredApproved.length} of {approvedStudents.length} approved students
                  </div>
                )}

                {/* Approved Students Table */}
                <div className="ar-table-container">
                  <table className="ar-table">
                    <thead>
                      <tr>
                        <th>SI No</th>
                        <th>Name</th>
                        <th>Admission Number</th>
                        <th>Course</th>
                        <th>Actions</th>
                      </tr>                    </thead>
                    <tbody>
                      {filteredApproved.length > 0 ? (
                        filteredApproved.map((student, index) => (
                          <tr key={student._id}>
                            <td>{index + 1}</td>
                            <td><strong>{student.name}</strong></td>
                            <td className="ar-mono-text">{student.admissionNumber}</td>
                            <td>
                              <span className="ar-status-approved">{student.course}</span>
                            </td>
                            <td>
                              <div className="ar-action-buttons">
                                <button className="ar-edit-btn" onClick={() => handlePreview(student)}>
  👁️ Preview
</button>
                                <button
                                  className="ar-edit-btn"
                                  onClick={() => handleEdit(student)}
                                >
                                  ✏️ Edit
                                </button>
                                <button
                                  className="ar-print-btn"
                                  onClick={() => handlePrintPreview(student._id, student.photo)}
                                >
                                  🖨️ Print
                                </button>
                                <button
                                  className="ar-delete-btn"
                                  onClick={() => handleDelete(student._id)}
                                >
                                  🗑️ Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="ar-empty-state">
                            {hasApprovedFilters ? "No matching approved students found" : "No approved students found"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        ) : (
          <StudentEditForm
            student={selectedStudent}
            studentId={studentId}
            onSave={handleSaveComplete}
            onCancel={() => {
              setEditMode(false);
              setSelectedStudent(null);
            }}
            isOpen={editMode}
            showAdmissionNumber={true}
          />
        )}
        {showPreview && (
  <StudentPreviewModal
    student={previewStudent}
    onClose={() => {
      setShowPreview(false);
      setPreviewStudent(null);
    }}
    onEdit={handlePreviewEdit}
  />
)}
      </div>
    </div>
  );
};

export default ApprovedAndRemoved;